import RawCode from "./specimens/RawCode";
import Audio from "./specimens/Audio";
import Code from "./specimens/Code";
import Color from "./specimens/Color";
import ColorPalette from "./specimens/ColorPalette";
import Html from "./specimens/Html";
import Hint from "./specimens/Hint";
import Image from "./specimens/Image";
import Table from "./specimens/Table";
import Type from "./specimens/Type";
import Download from "./specimens/Download";
import Video from "./specimens/Video";
import ReactSpecimen from "./specimens/ReactSpecimen/ReactSpecimen";

export default {
  "raw-code": RawCode,
  audio: Audio,
  code: Code,
  color: Color,
  "color-palette": ColorPalette,
  html: Html,
  hint: Hint,
  image: Image,
  table: Table,
  type: Type,
  download: Download,
  video: Video,
  react: ReactSpecimen
};
